
import { defineComponent } from "vue";

export default defineComponent({
  name: "ImageUpload",
  props: ['filechanged'],
  data() {
    return {
      selectedFile: null as File | null,
      imageUrl: "",
    };
  },
  methods: {
    handleFileChange(event: Event) {
      const input = event.target as HTMLInputElement;
      this.selectedFile = input.files?.[0] || null;
      this.previewImage();
      this.filechanged(this.selectedFile)
    },
    previewImage() {
      if (this.selectedFile) {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imageUrl = event.target?.result as string;
        };
        reader.readAsDataURL(this.selectedFile);
      } else {
        this.imageUrl = "";
      }
    }
  },
});
